import axios from 'axios';
import {
  generateChatElement,
  generateQABElement,
} from './chat-element/chat-element';
import { initSantaHandlers } from './santa-handlers/setup-santa-handlers';
import { isMobile } from 'is-mobile';

export { expandWidget } from './santa-handlers/santa-handlers';

function fetchDataByToken(token) {
  return axios
    .get(
      `https://engage.wixapps.net/_api/chat-standalone/external-chat-widget/token/${token}`,
    )
    .then((response) => response.data);
}

function fetchChatData(instance) {
  return axios
    .get(`/_api/chat-standalone/external-chat-widget/${instance}`)
    .then((response) => response.data);
}

const appendChatToDom = ({
  instance,
  chatDataPublic,
  siteColors,
  userStyles,
  url,
  host,
}) => {
  if (!userStyles) {
    return;
  }
  const chatElement = generateChatElement({
    instance,
    chatData: { ...chatDataPublic, userStyles },
    siteColors,
    url,
    host,
  });
  if (chatElement) {
    document.body.appendChild(chatElement);
    isMobile() && document.body.appendChild(generateQABElement());
  }
};

export const init = ({
  instance,
  initialMessage,
  pageTitle,
  locale,
  host = 'Standalone',
}) => {
  initSantaHandlers({ initialMessage, pageTitle, locale });
  fetchChatData(instance).then(({ chatDataPublic, siteColors, userStyles }) =>
    appendChatToDom({ chatDataPublic, siteColors, userStyles, instance, host }),
  );
};

export const initByToken = (token, initialMessage, pageTitle) => {
  initSantaHandlers({ initialMessage, pageTitle });
  fetchDataByToken(token).then(appendChatToDom);
};
